import {usePage} from "@inertiajs/vue3";
import Bugsnag from "@bugsnag/js";

export function getMainAuditionsUrl(isUserLoggedIn, routePrefix) {
    return isUserLoggedIn ?
        route('members2.reels.tag') + '?view=all&sort=newest' :
        route(routePrefix + '.reels.tag') + '?view=all&sort=newest'
}

export function getCastingsUrl(isUserLoggedIn, routePrefix) {
    return isUserLoggedIn ?
        route('members2.reels.tag') + '?view=castings' :
        route(routePrefix + '.reels.tag') + '?view=castings';
}

export function getCreateCastingUrl(isUserLoggedIn, routePrefix) {
    return isUserLoggedIn ?
        route('members2.studio.create-scene') :
        route(routePrefix + '.studio.create-scene');
}

export function getMineAuditionsUrl(isUserLoggedIn, routePrefix) {
    return isUserLoggedIn ?
        route('members2.reels.tag') + '?view=mine' :
        route(routePrefix + '.reels.tag') + '?view=mine';
}

export function trackAuditionAnalyticsEvent(event, audition, options = {}) {
    if (typeof LTIAnalytics !== 'undefined') {
        const {props} = usePage()
        const isUserLoggedIn = props.auth && props.auth.user && props.auth.user.id !== null
        const isTrialUser = props.auth && props.auth.is_trial
        const isGoldUser = props.auth?.is_gold || false

        LTIAnalytics.init(props.lti_analytics.api_key, {
            endpoint: props.lti_analytics.api_url + '/api/v1',
            debug: true,
            autoTrack: false
        });

        if (audition && audition.is_audition) {
            let data = {
                video_id: audition.id,
                video_slug: audition.slug,
                video_title: audition.title,
                video_avatar: audition.creator.avatar,
                video_username: audition.username,
                video_start_card_image: audition.start_card_image,
                video_stars_received: audition.likes,
                video_star_goal: audition.star_goal,
                video_categories: audition.categories.map(category => category.name.toLowerCase()).join(','),

                creator_name: audition.creator?.name,
                created_at: audition.original_created_at,
                published_at: audition.published_at,
                user_id: props?.auth?.user?.id ?? null,
                username: props?.auth?.user?.name ?? null,
                user_type: isUserLoggedIn ? 'member' : 'visitor',
                user_is_gold: isGoldUser ? 'true' : 'false',
                user_is_trial: isTrialUser ? 'true' : 'false',
                user_remaining_balance: audition.user_remaining_balance || 0,
                stars_given: audition.stars_given || 0,
            };

            if (options.store_in_local_storage) {
                if (options.local_storage_key) {
                    if (options.append_data) {
                        data = {
                            ...data,
                            ...options.append_data
                        };
                    }
                    localStorage.setItem(options.local_storage_key, JSON.stringify(data));
                    console.log(`++ LTI Analytics: Stored data in local storage key :: ${options.local_storage_key}`);
                } else {
                    console.error('++ LTI Analytics: Indication to store data in local storage, but no local storage key provided');
                }
            }

            LTIAnalytics.track(event, data);
            console.log(`++ LTI Analytics: Tracked ${event}`);
        }
    } else {
        console.error(`++ LTI Analytics: Failed to track event ${event}. LTIAnalytics is not defined`);
        Bugsnag.notify(new Error('LTI Analytics is not defined'), function (bugsnagEvent) {
            bugsnagEvent.severity = 'warning';
            if (audition) {
                bugsnagEvent.addMetadata('eventData', audition);
            }
        })
    }
}
